import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {getValueOfFeature} from '../../../util/values';
import {selectSpcConfiguration} from '../../../selectors';

@customElement('svg-optics-specsheet')
export class SvgOptics extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		width: 100%;
	  }

	  svg {
		height: 100%;
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.status = state.status;
	}

	render() {
		const s = this.state;
		const svgPath = this.status.host + this.status.baseUrl + '/visuals/line-optic.svg';
		let housingType = getValueOfFeature('shared::ProductType::HS_HousingType', this.spcConfiguration);
		if (housingType === 'WallSurface') {
			housingType = 'PoleLateral';
		}
		const moduleSize = getValueOfFeature('root::LightEngine_1::LE_LightEngineModuleSize', this.spcConfiguration) ?? 'M3';
		const housing = (housingType === 'Column' || housingType === 'Bollard') ? housingType : housingType + '_'+ moduleSize;

		let extra;
		switch (getValueOfFeature('shared::ProductType::HS_HousingType', this.spcConfiguration)) {
			case 'WallSurface':
			case 'WallRecessed':
				extra = 'Wall_extra';
				break;
			case 'PoleLateral':
				extra = 'PoleLateral_extra';
				break;
			case 'PoleTop':
				extra = 'PoleTop_extra';
				break;
			default:
				extra = false;
		}

		const reflectorColour = getValueOfFeature('root::LightEngine_1::LE_ReflectorColour', this.spcConfiguration) ?? 'Gold';
		const version = getValueOfFeature('root::LightEngine_1::LE_OpticalVersion', this.spcConfiguration) ?? 'Performance';
		const colourTemperature = getValueOfFeature('root::LightEngine_1::LE_ColourTemperature', this.spcConfiguration);
		const lightDistribution = getValueOfFeature('root::LightEngine_1::LE_LightDistribution', this.spcConfiguration);

		let offset = housingType === 'Bollard' ? -290 : 0;
		if (housingType !== 'Column' && housingType !== 'Bollard') {
			switch (moduleSize) {
				case 'M1':
					offset = 920;
					break;
				case 'M3':
				case 'M3F':
					offset = 757;
					break;
				case 'M6':
					offset = 482;
					break;
				case 'M12':
					offset = 30;
					break;
				default:
					offset = 0;
			}
		}
		offset = offset - 290;

		return svg`
			<svg id="productimage-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="2855" height="2855" viewBox="0 0 2855 2855">
				<g id="line-optic" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(1427.5,1550.56) translate(-1427.5,-1550.56)">
					<g id="Housing" transform="translate(867.5,1550.56) translate(-1427.5,-1550.56)">
									${when(extra, () => svg`<use href="${svgPath}#${extra}"></use>`)}
									<use href="${svgPath}#${housing}"></use>
					</g>
					<g id="Modules" transform="translate(867,1429) translate(-150,-1147)">
						<g id="Gold_M1_ComfortOptic" transform="translate(150,372) translate(-150,-91)">
								<use href="${svgPath}#${reflectorColour}_${moduleSize}_${version}" style="transform: translateY(${offset}px)"></use>
						</g>
					</g>
				</g>
			</svg>

		`;
	}
}
